import PropTypes from 'prop-types';

import classNames from 'classnames';

const IconGeneric = ({ name, title = '', color = '', size = '' }) => {
  const nameClass = `icon--${name}`;
  const colorClass = color && `icon__${color}`;
  const sizeClass = size && `icon__${size}`;

  const iconClassName = classNames('icon', nameClass, colorClass, sizeClass);

  if (name === 'twin-beds') {
    return (
      <span>
        <i className="icon icon--single-bed" title={title} />
        <span className="icon--counter">2 </span>
      </span>
    );
  }

  return <i className={iconClassName} title={title} />;
};

IconGeneric.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string
};

export default IconGeneric;
